import {
    CLEAR_FORM_FIELDS,
    CLEAR_FORMULA_DETAILS,
    CLEAR_FORMULA_LIST,
    FORMULA_DELETE_CONFIRMATION_CLOSE,
    FORMULA_DELETE_CONFIRMATION_OPEN,
    FORMULA_DELETE_ERROR,
    FORMULA_DELETE_ERROR_CLEAR,
    FORMULA_DELETE_PENDING,
    FORMULA_CREATE_DIALOG_CLOSE,
    FORMULA_CREATE_DIALOG_OPEN,
    FORMULA_CREATE_ERROR,
    FORMULA_CREATE_ERROR_CLEAR,
    FORMULA_CREATE_PENDING,
    FORMULA_DETAIL_PENDING,
    FORMULA_EDIT_DIALOG_CLOSE,
    FORMULA_EDIT_DIALOG_OPEN,
    FORMULA_EDIT_ERROR,
    FORMULA_EDIT_ERROR_CLEAR,
    FORMULA_EDIT_PENDING,
    FORMULA_EXPORT_ERROR,
    FORMULA_EXPORT_ERROR_CLEAR,
    FORMULA_EXPORT_PENDING,
    FORMULA_LIST_ERROR,
    FORMULA_LIST_ERROR_CLEAR,
    FORMULA_LIST_PENDING,
    SET_FORM_FIELDS,
    SET_FORMULA_DELETE_DATA,
    SET_FORMULA_DETAILS,
    SET_FORMULA_LIST,
    FORMULA_FILTER_DIALOG_OPEN,
    FORMULA_FILTER_DIALOG_CLOSE,
    SET_FORMULA_FILTER_DATA
} from "./constants"

const initialState = {
    //-----------------------------|| LIST ||---------------------------------------------------------------
    formulaList: null,
    formulaListCount: 0,
    isFormulaListPending: false,
    formulaListErrorMessage: null,
    //-----------------------------|| FILTER ||-------------------------------------------------------------
    isFormulaFilterDialogOpen: false,
    formulaFilterData: null,
    //-----------------------------|| EXPORT ||-------------------------------------------------------------
    isFormulaExportPending: false,
    formulaExportErrorMessage: null,
    //-----------------------------|| DETAIL ||-------------------------------------------------------------
    formulaDetails: {},
    isFormulaDetailsPending: false,
    //-----------------------------|| CREATE ||-------------------------------------------------------------
    isFormulaCreateDialogOpen: false,
    formFields: [],
    formFieldsCount: 0,
    isFormulaCreatePending: false,
    formulaCreateErrorMessage: null,
    //-----------------------------|| EDIT ||---------------------------------------------------------------
    isFormulaEditDialogOpen: false,
    isFormulaEditPending: false,
    formulaEditErrorMessage: null,
    //-----------------------------|| DELETE ||-------------------------------------------------------------
    formulaDeleteConfirmationDialogOpen: false,
    selectedFormulaDelete: null,
    isFormulaDeletePending: false,
    formulaDeleteErrorMessage: null,

}

const formulae = (state = initialState, action) => {

    switch (action.type) {
        //-----------------------------|| LIST ||---------------------------------------------------------------
        case FORMULA_LIST_PENDING: {
            return {
                ...state,
                isFormulaListPending: true,
                formulaListErrorMessage: null,
            }
        }

        case SET_FORMULA_LIST: {
            const { formulaList } = action.payload || {};
            return {
                ...state,
                formulaList: formulaList['value'],
                formulaListCount: formulaList['@odata.count'],
                isFormulaListPending: false,
                formulaListErrorMessage: null,
            }
        }

        case FORMULA_LIST_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                formulaListErrorMessage: errorMessage,
                isFormulaListPending: false,
                formulaList: null,
                formulaListCount: 0,
            }
        }

        case FORMULA_LIST_ERROR_CLEAR: {
            return {
                ...state,
                formulaListErrorMessage: null,
                isFormulaListPending: false,
            }
        }
        case CLEAR_FORMULA_LIST: {
            return {
                ...state,
                formulaList: null,
                formulaListCount: 0,
            }
        }

        //-----------------------------|| FILTER ||-------------------------------------------------------------
        case FORMULA_FILTER_DIALOG_OPEN: {
            return {
                ...state,
                isFormulaFilterDialogOpen: true,
            }
        }
        case FORMULA_FILTER_DIALOG_CLOSE: {
            return {
                ...state,
                isFormulaFilterDialogOpen: false,
            }
        }

        case SET_FORMULA_FILTER_DATA: {
            const { filter } = action.payload || {};
            return {
                ...state,
                formulaFilterData: filter,
            }
        }

        //-----------------------------|| EXPORT ||---------------------------------------------------------------
        case FORMULA_EXPORT_PENDING: {
            return {
                ...state,
                isFormulaExportPending: true,
                formulaExportErrorMessage: null,
            }
        }

        case FORMULA_EXPORT_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                formulaExportErrorMessage: errorMessage,
                isFormulaExportPending: false,
            }
        }

        case FORMULA_EXPORT_ERROR_CLEAR: {
            return {
                ...state,
                formulaExportErrorMessage: null,
                isFormulaExportPending: false,
            }
        }
        //-----------------------------|| DETAILS ||--------------------------------------------------------------
        case FORMULA_DETAIL_PENDING: {
            const { id } = action.payload || {};
            return {
                ...state,
                isFormulaDetailsPending: id,
                formulaExportErrorMessage: null,
            }
        }
        case SET_FORMULA_DETAILS: {
            const { formulaDetails } = action.payload || {};
            return {
                ...state,
                formulaDetails: formulaDetails,
                isFormulaDetailsPending: false
            }
        }
        case CLEAR_FORMULA_DETAILS: {
            return {
                ...state,
                formulaDetails: {},
            }
        }
        //-----------------------------|| CREATE ||---------------------------------------------------------------
        case FORMULA_CREATE_DIALOG_OPEN: {
            return {
                ...state,
                isFormulaCreateDialogOpen: true,
            }
        }

        case FORMULA_CREATE_DIALOG_CLOSE: {
            return {
                ...state,
                isFormulaCreateDialogOpen: false,
            }
        }

        case SET_FORM_FIELDS: {
            const { formFields } = action.payload || {};
            return {
                ...state,
                formFields: formFields["value"],
                formFieldsCount: formFields["@odata.count"]
            }
        }

        case CLEAR_FORM_FIELDS: {
            return {
                ...state,
                formFields: [],
                formFieldsCount: 0,
            }
        }

        case FORMULA_CREATE_PENDING: {
            return {
                ...state,
                isFormulaCreatePending: true,
                formulaCreateErrorMessage: null,
            }
        }

        case FORMULA_CREATE_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                formulaCreateErrorMessage: errorMessage,
                isFormulaCreatePending: false,
            }
        }

        case FORMULA_CREATE_ERROR_CLEAR: {
            return {
                ...state,
                formulaCreateErrorMessage: null,
                isFormulaCreatePending: false,
            }
        }

        //-----------------------------|| EDIT ||---------------------------------------------------------------
        case FORMULA_EDIT_DIALOG_OPEN: {
            return {
                ...state,
                isFormulaEditDialogOpen: true,
            }
        }
        case FORMULA_EDIT_DIALOG_CLOSE: {
            return {
                ...state,
                isFormulaEditDialogOpen: false,
            }
        }

        case FORMULA_EDIT_PENDING: {
            return {
                ...state,
                isFormulaEditPending: true,
                formulaEditErrorMessage: null,
            }
        }

        case FORMULA_EDIT_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                formulaEditErrorMessage: errorMessage,
                isFormulaEditPending: false,
            }
        }

        case FORMULA_EDIT_ERROR_CLEAR: {
            return {
                ...state,
                formulaEditErrorMessage: null,
                isFormulaEditPending: false,
            }
        }

        //-----------------------------|| DELETE ||-------------------------------------------------------------
        case FORMULA_DELETE_CONFIRMATION_OPEN: {
            return {
                ...state,
                formulaDeleteConfirmationDialogOpen: true,
            }
        }

        case FORMULA_DELETE_CONFIRMATION_CLOSE: {
            return {
                ...state,
                formulaDeleteConfirmationDialogOpen: false,
            }
        }
        case SET_FORMULA_DELETE_DATA: {
            const { selectedFormula } = action.payload || {};
            return {
                ...state,
                selectedFormulaDelete: selectedFormula,
            }
        }

        case FORMULA_DELETE_PENDING: {
            return {
                ...state,
                isFormulaDeletePending: true,
                formulaDeleteErrorMessage: null,
            }
        }

        case FORMULA_DELETE_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                formulaDeleteErrorMessage: errorMessage,
                isFormulaDeletePending: false,
            }
        }

        case FORMULA_DELETE_ERROR_CLEAR: {
            return {
                ...state,
                formulaDeleteErrorMessage: null,
                isFormulaDeletePending: false,
            }
        }

        default: {
            return state
        }
    }
}

export default formulae